import { useMemo } from 'react';

import PropTypes from 'prop-types';

import Text from 'bloko/blocks/text';

import useTrls from 'hooks/translation/useTrls';

import TableCell from 'components/Table/TableCell';
import TableRow from 'components/Table/TableRow';

const Total = ({ charges }) => {
    const trl = useTrls();

    const totals = useMemo(() => {
        const result = {
            amount: 0,
        };
        charges.forEach((charge) => {
            result.amount += charge.amount;
        });
        return result;
    }, [charges]);

    return (
        <TableRow>
            <TableCell>{trl('admin.Invoices.InvoicesDetail.Invoice.Charges.Total')}</TableCell>
            <TableCell>
                <Text Element="span" strong>
                    {totals.amount}
                </Text>
            </TableCell>
            <TableCell />
        </TableRow>
    );
};

Total.propTypes = {
    charges: PropTypes.arrayOf(
        PropTypes.shape({
            amount: PropTypes.number,
        })
    ),
};

export default Total;
